namespace LocaleConstants {
  export const NAME_MAX_LENGTH = 256;
  export const LOCALE_SHORTCODE_MAX_LENGTH = 20;
}

export default LocaleConstants;
